import {
  Checkbox,
  Input,
  ListItemText,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';
import { forms, pslfStatus, statuses } from './dropdowns';
import { useEffect, useMemo, useState } from 'react';

const FormsFilter = ({ formFilter, onSelectForm, onSelectDate, onClose }) => {
  const [openForm, setOpenForm] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const getSelectedFormLabel = (value) => {
    if (value) {
      const label = forms.find((each) => each.value === value).label;
      return <span>{label}</span>;
    }
    return <span>Filter by Forms</span>;
  };
  const formStatuses = useMemo(() => {
    if (["pslfec", "pslfa"].includes(formFilter.form)) {
      return pslfStatus;
    }
    return statuses;
  }, [formFilter.form]);

  const getSelectedStatus = (value) => {
    if (value) {
      const label = formStatuses.find((each) => each.value === value).label;
      return <span>{label}</span>;
    }
    return <span>Filter by Forms status</span>;
  };

  return (
    <div className='row mt-4'>
      <div className='col-4'>
        <Paper style={{ display: 'flex' }} elevation={1}>
          <Select
            open={openForm}
            onOpen={() => setOpenForm(true)}
            onClose={() => {
              onClose();
              setOpenForm(false);
            }}
            labelId='forms'
            className='data-filter'
            value={formFilter.form}
            renderValue={getSelectedFormLabel}
            style={{ width: '100%' }}
            onChange={(e, child) => onSelectForm(e, child, 'form')}
            displayEmpty
          >
            {forms.map(({ value, label }) => (
              <MenuItem key={value} value={{ value, label }}>
                <ListItemText primary={label} />
              </MenuItem>
            ))}
          </Select>
        </Paper>
      </div>
      {formFilter.form && (
        <>
          <div className='col-4'>
            <Paper style={{ display: 'flex' }} elevation={1}>
              <Select
                open={openStatus}
                onOpen={() => setOpenStatus(true)}
                onClose={() => {
                  onClose();
                  setOpenStatus(false);
                }}
                labelId='status'
                className='data-filter'
                value={formFilter.status}
                renderValue={getSelectedStatus}
                style={{ width: '100%' }}
                onChange={(e, child) => onSelectForm(e, child, 'status')}
                displayEmpty
              >
                {formStatuses.map(({ value, label }) => (
                  <MenuItem key={value} value={{ value, label }}>
                    <ListItemText primary={label} />
                  </MenuItem>
                ))}
              </Select>
            </Paper>
          </div>
          <div className='col-2'>
            <p style={{ marginBottom: 0 }}>From:</p>
            <Input
              type='date'
              value={formFilter.from}
              onChange={(e) => onSelectDate('from', e.target.value)}
            />
          </div>
          <div className='col-2'>
            <p style={{ marginBottom: 0 }}>To:</p>
            <Input
              type='date'
              value={formFilter.to}
              onChange={(e) => onSelectDate('to', e.target.value)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default FormsFilter;
